import * as R from 'ramda'

import { hasAddress } from '../typeguards/hasAddress'

import type { LocationStepValues } from '@ngb-frontend/shared/types'

export const hasLocationValues = (x: unknown): x is LocationStepValues =>
  R.allPass([R.pipe(R.prop('location'), hasAddress)])(x)
